//
//
//
//
//
//
//

export default {
    name: 'AppBadge',

    props: {
        text: {
            required: false,
            type: String,
        },

        color: {
            required: false,
            type: String,
            default: 'muted',
        },

        size: {
            required: false,
            type: String,
            default: 'md',
        },
    },

    computed: {
        colorStyles() {
            return {
                error: 'border border-error border-opacity-30 bg-error bg-opacity-10 text-error',
                warning: 'border border-warning border-opacity-30 bg-warning bg-opacity-10 text-warning',
                success: 'border border-success border-opacity-30 bg-success bg-opacity-10 text-success',
                primary: 'border border-primary border-opacity-10 bg-primary bg-opacity-10 text-primary',
                neutral: 'border border-border-form bg-background-primary bg-opacity-10',
                ternary: 'bg-background-ternary text-copy-primary',
                muted: 'bg-copy-muted text-white',
                tooltip: 'bg-background-tooltip text-copy-primary-invert',
                white: 'bg-white text-black',
            }[this.color];
        },

        sizeStyles() {
            return {
                tiny: 'text-tiny px-2',
                xs: 'text-xs px-4',
                sm: 'text-sm px-4',
                md: 'text-md px-4',
            }[this.size];
        },
    },
};
